
import State from "slotworks/state-machine/states/state";

export default class RevolverOpen extends State {

    public onEnter() {
        this.complete();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/states/revolver-open.ts